import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";
/**
 * @description Get the member info for a society
 */

export function member(instanceId, api) {
  return memo(instanceId, function (accountId) {
    return api.queryMulti([[api.query.society.payouts, accountId], [api.query.society.strikes, accountId], [api.query.society.defenderVotes, accountId], [api.query.society.suspendedMembers, accountId], [api.query.society.vouching, accountId]]).pipe(map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 5),
          payouts = _ref2[0],
          strikes = _ref2[1],
          defenderVotes = _ref2[2],
          suspended = _ref2[3],
          vouching = _ref2[4];

      return {
        accountId: accountId,
        isSuspended: suspended.isTrue,
        payouts: payouts,
        strikes: strikes,
        vote: defenderVotes.unwrapOr(undefined),
        vouching: vouching.unwrapOr(undefined)
      };
    }));
  });
}